module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+cAAAAPCAYAAACGAb7OAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAK9JREFUeNrs1yEBADAMA8F6mn9vAwVzsIBc0OFnmdmdeWNmZmZmZmbm/xaDmZmZmZmZOWkxmJmZmZmZmbMWg5mZmZmZmdlBZ2ZmZmZmZi63GMzMzMzMzMxZi8HMzMzMzMzsoDMzMzMzMzOXWwxmZmZmZmbmrMVgZmZmZmZmdtCZmZmZmZmZyy0GMzMzMzMzc9ZiMDMzMzMzMzvozMzMzMzMzOUWg5mZmZmZmTnoK8AATnjjR5SvJvEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot/titlebg.png
// module id = ultI
// module chunks = 1